<template>
  <el-dialog
    title="选择模型"
    :visible.sync="modelVisiable"
    class="small-dialog"
    :close-on-click-modal="false"
    v-dialogDrag
    @open="openDialog"
    :before-close="closeModelDialog"
  >
    <div>
      <el-input
        v-model="modelKeywords"
        class="w-200px mr-10px"
        clearable
        placeholder="请输入模型名称"
      ></el-input>
      <el-button type="primary" @click="searchModelData">{{ $t('search') }}</el-button>
    </div>
    <el-table
      :data="modelData"
      v-loading="modelLoading"
      border
      class="mt-20px"
      height="calc(100% - 104px)"
      @selection-change="selectModel"
      row-key="id"
      ref="modelTable"
    >
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="directoryPath"
        label="模型分类"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="name" label="模型名称" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="mt-20px float-right">
      <el-pagination
        background
        @size-change="handleSizeModel"
        @current-change="handleCurrentModel"
        :current-page.sync="model.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size="model.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="model.total"
      ></el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="closeModelDialog">{{ `${$t('Cancel')}` }}</el-button>
      <el-button type="primary" @click="submitModel">{{ `${$t('Sure')}` }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ModelApi } from '@wiz-api/material-management'

const modelApi = new ModelApi()
export default {
  props: ['modelVisiable', 'type'],
  data() {
    return {
      modelKeywords: '',
      modelData: [],
      modelLoading: false,
      selectModelList: [],
      model: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  methods: {
    openDialog() {
      this.modelKeywords = ''
      this.model.pageNo = 1
      this.model.pageSize = 15
      this.searchModelData()
    },
    selectModel(val) {
      this.selectModelList = val
    },
    handleSizeModel(pageSize) {
      this.model.pageSize = pageSize
      this.searchModelData()
    },
    handleCurrentModel(pageNo) {
      this.model.pageNo = pageNo
      this.searchModelData()
    },
    async searchModelData() {
      this.modelLoading = true
      const [err, res] = await modelApi.getList({
        name: this.modelKeywords,
        skipCount: (this.model.pageNo - 1) * this.model.pageSize,
        maxResultCount: this.model.pageSize,
      })
      this.modelLoading = false
      if (!err) {
        this.modelData = _.map(res.items, (item) => {
          item.directoryPath = item.directoryPath.split('/')[1]
          return item
        })
        this.model.total = res.totalCount
      }
    },
    closeModelDialog() {
      this.selectModelList = []
      if (this.$refs.modelTable) {
        this.$refs.modelTable.clearSelection()
      }
      this.$emit('closeModelDialog')
    },
    submitModel() {
      if (this.selectModelList.length === 0) {
        this.$message.warning('请选择模型')
        return
      }
      if (this.type === 'relation' && this.selectModelList.length > 1) {
        this.$message.warning('关联模型只能选择一个')
        return
      }
      this.$emit('updateModelData', this.selectModelList)
      this.closeModelDialog()
    },
  },
}
</script>
